import {BasePalette} from '#core/application/modules/base-palette.js';
import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';

import {MobileNavBar} from '../mobile-nav-bar.js';

import {mobileNavBarAvantgardeFactory} from './mobile-nav-bar-avantgarde.factory.js';

import SCHEMA from './mobile-nav-bar-avantgarde.schema.yaml';
import PALETTE_SCHEMA from './mobile-nav-bar-avantgarde.palette-schema.yaml';

class MobileNavBarAvantgardeFeature extends AbstractVisualFeature {
    get enabled() {
        return BasePalette.isAvantgarde();
    }

    get name() {
        return 'Mobile NavBar Avantgarde';
    }

    get configSchema() {
        return SCHEMA;
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return mobileNavBarAvantgardeFactory(PALETTE);
    }
}

new MobileNavBarAvantgardeFeature(MobileNavBar);
